export { CellDetailsMobile } from "./CellDetailsMobile";
